<template>
  <div class="p-2 sm:p-4">
    <div class="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
      <h1>Sponsors</h1>
      <div class="flex">
        <template v-if=" adminData.event.status !== 'ARCHIVED'">
          <button class="btn-green btn-sm" @click="showSponsorModal(false)">+ Add Sponsor</button>
          <button class="btn-gray-outline btn-sm mx-1" @click="saveOrder">Save Order</button>
        </template>
        <button class="btn-link" @click="downloadSponsorData">Download Data</button>
      </div>
    </div>
    <draggable v-model="adminData.event.sponsors" group="market" ghost-class="ghost" handle=".handle">
      <div class="flex border-t p-2 hover:bg-gray-300 items-center" v-for="(s, i) in sponsors" :key="i">
        <span class="text-xl handle draggable mx-1">&#9776;</span>
        <div class="flex flex-col text-center justify-center flex-1">
          <div class="font-semibold text-lg">{{s.sponsor_details.description}}</div>
          <div class="font-light text-lg">
            <a v-if="s.sponsor_details.website" :href="s.sponsor_details.website" target="_blank">{{`${s.sponsor_details.name}`}}<span v-if="s.sponsor_details.city">{{` ~ ${s.sponsor_details.city}, ${s.sponsor_details.state}`}}</span></a>
            <div v-else>{{`${s.sponsor_details.name}`}}<span v-if="s.sponsor_details.city">{{` ~ ${s.sponsor_details.city}, ${s.sponsor_details.state}`}}</span></div>
          </div>
        </div>
        <div v-if="adminData.event.status !== 'ARCHIVED'">
          <button class="btn-blue-outline btn-xs m-2" @click="showSponsorModal(s)">Edit</button>
          <button class="btn-red-outline btn-xs m-2" @click="deleteSponsor(s, i)">X</button>
        </div>
      </div>
    </draggable>
    <b-modal id="sponsorModal" ref="sponsorModal" size="lg" title="Sponsor" no-close-on-backdrop>
      <form autocomplete="off" class="w-full mt-4">
        <input autocomplete="false" name="hidden" type="text" style="display:none;">
        <div v-for="s in sponsorSchema" :key="s.label">
          <h3 class="mb-2 pb-1 border-b">{{s.label}}</h3>
          <div v-for="d in s.fields" :key="d.label" class='mb-4'>
            <template v-if="d.type!='actions'">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="d.model">
                {{d.label}}
              </label>
              <input v-if="d.type=='input'" :type="d.inputType" v-model="s.model[d.model]" :placeholder="d.label" class="text-input focus:outline-none focus:shadow-outline">
              <textarea v-else-if="d.type=='textArea'" v-model="s.model[d.model]" :placeholder="d.label" class="text-input"/>
              <input v-else-if="d.type=='checkbox'" v-model="s.model[d.model]" class="mr-2 leading-tight" type="checkbox">
              <p class="text-sm text-gray-600" v-if="d.hint">{{d.hint}}</p>

            </template>
            <template>
              <div class="flex justify-center">
                <button v-for="a in d.actions" :key="a.buttonText" @click="a.onSubmit" class="mx-1 shadow bg-blue hover:bg-blue-dark focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded" type="button">
                  {{a.buttonText}}
                </button>
              </div>
            </template>
          </div>
        </div>
      </form>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-green mr-3" @click="saveSponsor">Save</button>
        <button class="btn btn-gray-outline" variant="primary" @click="$refs.sponsorModal.hide()">
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data () {
    return {
      sponsor: {
        sponsor_details: {}
      }
    }
  },
  methods: {
    showSponsorModal (sponsor) {
      if (sponsor) {
        this.sponsor = sponsor
      } else {
        this.sponsor = {
          event_id: this.adminData.event.event_id,
          sponsor_details: {}
        }
      }
      this.$refs.sponsorModal.show()
    },
    saveSponsor () {
      this.sponsor.sponsor_details.website = this.formatWebsite(this.sponsor.sponsor_details.website)
      // this.sponsor.admin_id = this.adminData.event.admin_id
      this.$store.dispatch('saveSponsor', this.sponsor)
        .then(result => {
          this.$refs.sponsorModal.hide()
        })
    },
    saveOrder () {
      this.sponsors.forEach((s, i) => {
        if (s.order !== i + 1) {
          s.order = i + 1
          this.$store.dispatch('saveSponsor', s)
        }
      })
    },
    deleteSponsor (sponsor, index) {
      this.$store.dispatch('deleteSponsor', {sponsor_id: sponsor.sponsor_id, index: index})
    },
    formatWebsite (website) {
      if (website) {
        let webRe = /^https?:\/\/(.*)/i
        var hasHttp = website.match(webRe)
        if (hasHttp) {
          return website
        } else {
          return 'https://' + website
        }
      }
      return ''
    },
    downloadSponsorData () {
      this.exportCSVFile(`${this.eventName}_sponsor_data`, this.exportableSponsors, this.exportHeaders)
    },
    // CSV Export
    flattenObject (object) {
      var toReturn = {}

      for (var i in object) {
        if (!object.hasOwnProperty(i)) continue

        if (typeof object[i] === 'object') {
          var flatObject = this.flattenObject(object[i])

          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) continue
            toReturn[i + '.' + x] = flatObject[x]
          }
        } else {
          toReturn[i] = object[i]
        }
      }
      return toReturn
    },
    createHeaderString (headers) {
      var headerStr = ''
      headers.forEach(h => {
        headerStr += h.header + ','
      })
      headerStr += '\r\n'
      return headerStr
    },
    convertToCSV (objArray, headers) {
      var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

      this.csvStr = this.createHeaderString(headers)

      for (var i = 0; i < array.length; i++) {
        var line = ''
        var object = this.flattenObject(array[i])

        headers.forEach(h => {
          if (line !== '') line += ','
          line += object[h.field] ? `"${object[h.field]}"` : '""'
        })

        this.csvStr += line + '\r\n'
      }
      return this.csvStr
    },
    exportCSVFile (fileTitle, objArray, headers) {
      /* if (headers) {
        items.unshift(headers);
      } */

      // var breedingCSV = this.convertToCSV(this.flattenEntires_shows(this.entries.filter(s => { return s.classType === 'BREEDING' })), this.breedingHeaders)
      // var marketCSV = this.convertToCSV(this.flattenEntires_shows(this.entries.filter(s => { return s.classType === 'MARKET' })), this.marketHeaders)
      // var showmanshipCSV = this.convertToCSV(this.flattenEntires_shows(this.entries.filter(s => { return s.classType === 'SHOWMANSHIP' })), this.showmanshipHeaders)
      let csvData = this.convertToCSV(objArray, headers)
      var toDownload = [{
        csv: csvData,
        fileName: fileTitle + '.csv' || 'export.csv'
      }]

      toDownload.forEach(d => {
        var blob = new Blob([d.csv], {type: 'text/csv;charset=utf-8;'})
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, d.fileName)
        } else {
          var link = document.createElement('a')
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', d.fileName)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      })
    }
  },
  computed: {
    eventName () {
      return this.$store.state.admin.adminData.event.name
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    sponsors () {
      return this.adminData.event.sponsors
    },
    sponsorSchema () {
      return [
        {
          label: 'Sponsor',
          model: this.sponsor.sponsor_details,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Contact Name',
              model: 'contact_name',
              placeholder: '',
              hint: '**This info will NOT show up on the public sponsor list**'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Description',
              model: 'description',
              placeholder: 'Description',
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Name of Sponsor',
              model: 'name',
              placeholder: 'Name of sponsor',
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Address',
              model: 'address',
              placeholder: 'Address',
              hint: '**This info will NOT show up on the public sponsor list**'

            },
            {
              type: 'input',
              inputType: 'text',
              label: 'City',
              model: 'city',
              placeholder: 'city'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'State',
              model: 'state',
              placeholder: 'state'
            },
            {
              type: 'input',
              inputType: 'number',
              label: 'Zip',
              model: 'zip',
              placeholder: 'Zip Code'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Phone Number',
              model: 'phone_number',
              placeholder: '',
              hint: '**This info will NOT show up on the public sponsor list**'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Email',
              model: 'email',
              placeholder: '',
              hint: '**This info will NOT show up on the public sponsor list**'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Website',
              model: 'website',
              placeholder: 'Website'
            },
            {
              type: 'input',
              inputType: 'number',
              label: 'Amount',
              model: 'sponsorshipAmount',
              hint: '**This info will NOT show up on the public sponsor list**'
            },
            {
              type: 'textArea',
              label: 'Comments',
              model: 'comments',
              hint: '**This info will NOT show up on the public sponsor list**'
            }
          ]
        }
      ]
    },
    exportableSponsors () {
      let data = []
      this.sponsors.forEach(s => {
        data.push({...s.sponsor_details,
          sponsor_id: s.sponsor_id,
          created_at: s.created_at
        })
      })
      return data
    },
    exportHeaders () {
      let headers = [
        {
          field: 'name',
          header: 'Name'
        },
        {
          field: 'description',
          header: 'Description'
        },
        {
          field: 'contact_name',
          header: 'Contact Name'
        },
        {
          field: 'email',
          header: 'Email'
        },
        {
          field: 'phone_number',
          header: 'Phone Number'
        },
        {
          field: 'address',
          header: 'Address'
        },
        {
          field: 'city',
          header: 'City'
        },
        {
          field: 'state',
          header: 'State'
        },
        {
          field: 'zip',
          header: 'Zip Code'
        },
        {
          field: 'website',
          header: 'Website'
        },
        {
          field: 'comments',
          header: 'Comments'
        },
        {
          field: 'sponsorshipAmount',
          header: 'Amount'
        },
        {
          field: 'created_at',
          header: 'Created At'
        },
        {
          field: 'sponsor_id',
          header: 'ID'
        }
      ]
      return headers
    }
  }
}
</script>

<style>
.draggable:hover {
    cursor: grab;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.handle {
  padding: 0;
}
</style>
